import Loader from 'components/Loader'
import React, { useEffect, useState } from 'react'
import BlogService from 'services/BlogService'
import { pageViewEvent } from 'services/conversionevents'
import useCache from 'store/CacheProvider'
import {
  BlogContent,
  BlogImage,
  BlogSideBar,
  BlogTitle,
  BlogWrapper,
  Description,
} from 'style/Blog.style'
import PostSuggestions from './components/PostSuggestions'

const SinglePost = props => {
  const slug = props.match.params.slug
  const { getCache } = useCache()
  const p = getCache('POST', {
    blog: {},
  })
  const [post, setPost] = useState(p.blog || {})

  useEffect(() => {
    if (slug === post.slug) return
    setPost({})
    BlogService.getBySlug(slug).then(data => {
      if (data.blog) {
        data.blog.suggestions = data.suggestions
        setPost(data.blog)
        document.title = data.blog.title
        window.scrollTo(0, 0)
      }
    })
    pageViewEvent()
    // eslint-disable-next-line
  }, [slug])

  if (!post.slug) {
    return <Loader visible={true} type="ThreeDots" />
  }

  return (
    <BlogWrapper>
      <BlogContent>
        <BlogTitle>
          <h2>{post.title}</h2>
          <p>
            <span className="cat">{post.category}</span>
            {post.created_at}
          </p>
        </BlogTitle>
        <BlogImage src={post.image} />
        <Description dangerouslySetInnerHTML={{ __html: post.content }} />
      </BlogContent>
      <BlogSideBar>
        <PostSuggestions
          posts={Array.isArray(post.suggestions) ? post.suggestions : []}
        />
      </BlogSideBar>
    </BlogWrapper>
  )
}

export default SinglePost
